import { atom } from 'jotai';
import { VersionFeatureInfo } from '../../../types/Users';

export interface FeatureFlagsState {
  isLoaded: boolean;
  isLoading: boolean;
  features: Record<string, boolean>;
  error: string | null;
}

export const initialFeatureFlagsState: FeatureFlagsState = {
  isLoaded: false,
  isLoading: false,
  features: {},
  error: null,
};

export const featureFlagsStateSegment = atom<FeatureFlagsState>(
  initialFeatureFlagsState
);

// Add debug label for Jotai dev tools
featureFlagsStateSegment.debugLabel = 'featureFlagsStateSegment';

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (
  featureFlagsState: FeatureFlagsState,
  featureName: string
): boolean => {
  return (
    featureFlagsState.isLoaded && !!featureFlagsState.features[featureName]
  );
};

// Helper function to convert feature info array to features object
export const convertFeatureInfoToFeatures = (
  featureInfo: VersionFeatureInfo[]
): Record<string, boolean> => {
  return featureInfo.reduce(
    (acc, feature) => {
      acc[feature.featureName] = feature.enabled;
      return acc;
    },
    {} as Record<string, boolean>
  );
};
